import { useEffect } from "react";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { FileBucketURL, DefaultImageType, AppConstants } from "../../configs";
import { CallParticipateResponseModel, OperatorFilterHistory } from "../../models/api/Call";
import { useFunctionalityImageView } from "../../pages/hooks/functionalityImageView";
type Props = {
    operators?: OperatorFilterHistory[];
    isOpen?: boolean;
    onToggle?: () => void;
};

export function CallSummaryOperatorHistories(props: Props): JSX.Element {
    const { operators, isOpen = false, onToggle } = props;

    const formatDuration = (seconds: number | null) => {
        if (seconds == null) return "N/A";
        const totalSeconds = Math.floor(seconds);
        const hrs = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
        const mins = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
        const secs = String(totalSeconds % 60).padStart(2, "0");
        return `${hrs}:${mins}:${secs}`;
    };

    return (
        <>
            <div className="card">
                <div className="card-header px-0 py-1" id="headingOperatorHistory">
                    <button
                        className={`btn btn-link w-100 text-start text-decoration-none text-site siteAccordion${isOpen ? "" : " collapsed"}`}
                        type="button"
                        aria-expanded={isOpen}
                        aria-controls="operator-history"
                        onClick={onToggle}
                    >
                        <div className="d-flex justify-content-between align-items-center">
                            <div>Occupancy Rate History</div>
                            <div>
                                <FontAwesomeIcon
                                    icon={faChevronDown}
                                    className="closed-panel-icon"
                                />
                                <FontAwesomeIcon
                                    icon={faChevronUp}
                                    className="open-panel-icon"
                                />
                            </div>
                        </div>
                    </button>
                </div>
                <div
                    className={`collapse${isOpen ? " show" : ""}`}
                    id="operator-history"
                    aria-labelledby="headingOperatorHistory"
                >
                    <div className="card-body px-3 py-1" style={{maxHeight: "175px", overflowY: "auto"}}>
                        <div className="row pt-2">
                            {operators && operators?.length > 0 ? (
                                <>
                                    {operators?.map((operator) => {
                                        return (
                                            <div className="col-12" key={operator.operatorName}>
                                                <div className="row px-2 pb-2">
                                                    <div className="col">
                                                        <div className="row ghost-box">
                                                            <div className="col-12 font-500 font-sz-14">{operator.operatorName}</div>

                                                            <div className="col-12">
                                                                <div className="me-3 font-sz-12 d-inline-block" style={{ minWidth: "130px" }}>
                                                                    Occupancy Rate: <span style={{ color: "var(--site-purple)" }}>{operator.occupancyRate != null
                                                                        ? (operator.occupancyRate).toFixed(2)
                                                                        : 'N/A'}
                                                                    </span>
                                                                </div>
                                                                <div className="me-3 font-sz-12 d-inline-block" style={{ minWidth: "150px" }}>
                                                                    Cumul. Duration:{" "}
                                                                    <span style={{ color: "var(--site-purple)" }}>
                                                                        {formatDuration(operator.cumulativeDuration)}
                                                                    </span>
                                                                </div>

                                                                <div className="me-3 font-sz-12 d-inline-block" style={{ minWidth: "150px" }}>
                                                                    Cumul. Available:{" "}
                                                                    <span style={{ color: "var(--site-purple)" }}>
                                                                        {formatDuration(operator.cumulativeAvilable)}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </>
                            ) : (
                                <>
                                    <div className="col pb-2">No Data</div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
